import { Box, Typography } from '@mui/material'
import { PageOuterContainer } from '../../root-components/layouts/page-outer-container'
import { CustomThemeContext } from '../../context/theme/custom-theme-context'
import { useContext } from 'react'
import { PageTitle } from '../presentation-components/display-elements-components/page-title'
import { useSearchParams } from 'react-router-dom'

export const TimeOutPage = () => {
  const customThemeContext = useContext(CustomThemeContext)
  const [searchParams] = useSearchParams()
  const type = searchParams.get('type') || 'import'

  const title =
    type === 'import'
      ? 'Upload Processing'
      : type === 'bulkDelete' || type === 'delete'
        ? 'Delete in Progress'
        : 'Update in Progress'

  const firstMessage =
    type === 'import'
      ? 'Your upload is currently being processed'
      : type === 'bulkDelete' || type === 'delete'
        ? 'Your records are currently being deleted'
        : 'Your records are currently being updated'

  const secondMessage =
    type === 'import'
      ? 'Please check back on the import history page later for the status'
      : type === 'bulkDelete' || type === 'delete'
        ? 'If this delete affects a large number of emissions, it may take some time to complete. Please do not run this delete again while in progress, as this could result in unintended changes.'
        : 'If this update affects a large number of emissions, it may take some time to complete. Please do not run this update again while in progress, as this could result in duplicate changes.'

  return (
    <PageOuterContainer>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', mt: 4 }}>
        <img
          src={customThemeContext.logoUrl}
          alt="GAIA logo"
          height="80"
          style={{ marginBottom: 32 }}
        />
        <PageTitle title={title} />
        <Typography sx={{ mt: 2 }}>{firstMessage}</Typography>
        <Typography sx={{ mt: 1, textAlign: 'center', maxWidth: 600 }}>{secondMessage}</Typography>
        <Typography sx={{ mt: 1, textAlign: 'center', maxWidth: 600, color: 'primary.main', }}>You can safely navigate away from this page.</Typography>
      </Box>
    </PageOuterContainer>
  )
}


